module.exports = __webpack_public_path__ + "static/images/styles/images/challenges/icon-conscription.5b209abf.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/challenges/icon-conscription.png
// module id = 3612
// module chunks = 11